<div class="vnpt-pay">
    <div class="background" [ngClass]="vnptpayResponseCode == '00' ? 'background-success' : 'background-failure'"></div>
    <div class="container-error">
        <div class="left-section">
            <div class="inner-content">
                <h1 class="heading">{{ message }}</h1>
                <p class="subheading">Order number: {{ data }}</p>
                <p class="subheading">{{ vnptpayResponseCode != '00' ? 'Payment failed, please pay again.' : 'Successful payment. Thank You!' }}</p>
                <div class="row btn-group">
                    <a class="btn btn-xs btn-go-home add-tooltip" title="Home" routerLink="/">Home</a>
                    <a class="btn btn-xs btn-go-back add-tooltip" title="Go back" (click)="goBack()">Go back</a>
                </div>
            </div>
        </div>
    </div>
</div>